export enum ActivityTypeCodesEnum {
    EXTERNAL_OT = '2PMFPM',
    EXTERNAL = '2PMFPN',
    ERLANGEN_OT1 = '2PMM',
    ERLANGEN = '2PMN',
    PRAGUE = '2PMNZR',
    SEOUL = '2PM5BM',
    DEFAULT_TEST = '2PM5BN',
    ERLANGEN_OT2 = '2PMS',
    EXT_SUPPORT = 'MSPEXN'
}
